import { useRef, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';

interface ModalViewFileProps {
  showModalDocReceived: boolean
  setShowModalDocReceived: React.Dispatch<React.SetStateAction<boolean>>
  docReceivedSelected: {
    nome: string
    url: string
  }
}

export function ModalViewFile({
   showModalDocReceived, 
   setShowModalDocReceived,
   docReceivedSelected
   }: ModalViewFileProps){
    const [loadingAttachments, setLoadingAttachments] = useState(false);
    const downloadLink = useRef(null);

    const handleIframeError = () => {
      setLoadingAttachments(false);
    };

    const isImage = (url) => {
      return url && /\.(jpg|jpeg|png)$/i.test(url);
    };

    const handleIframeLoad = () => {
      setLoadingAttachments(false);
    };

  return (
    <Modal
    show={showModalDocReceived}
    onHide={() => setShowModalDocReceived(false)}
    size="lg"
  >
    <Modal.Header closeButton>
      <Modal.Title>{docReceivedSelected?.nome}</Modal.Title>

    </Modal.Header>
    <Modal.Body style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '750px' }}>
      {isImage(docReceivedSelected?.url) ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <img
            src={docReceivedSelected?.url}
            alt={docReceivedSelected?.nome}
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
          />
        </div>
      ) : (
        <>
          {loadingAttachments && <Spinner />}
          <iframe
            title={docReceivedSelected?.nome}
            src={`https://docs.google.com/gview?url=${encodeURIComponent(docReceivedSelected?.url)}&embedded=true`}
            style={{
              width: "100%",
              height: "750px",
              border: "none",
              display: loadingAttachments ? 'none' : 'block'
            }}
            onLoad={handleIframeLoad}
            onError={handleIframeError}
          />
          <div style={{ textAlign: 'center' }}>
            <p>Se o documento não foi carregado automaticamente, clique no botão abaixo para fazer o download.</p>
          </div>
        </>
      )}
    </Modal.Body>
    <Modal.Footer>
      <a
        ref={downloadLink}
        href={docReceivedSelected?.url || "#"}
        download
        className="btn btn-primary"
        style={{ marginLeft: '10px' }}
      >
        Download
      </a>
    </Modal.Footer>
  </Modal>
  )
}